<template>
  <div class="rank-table-container">
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px;color: white;">抖音互动玩法榜</div>
      <div style="font-size: 20px;font-weight:bold;margin-top: 1%">{{ displayTime }}</div>
    </div>

    <!-- 弹出窗：加载中提示 -->
    <el-dialog
        v-model="isLoading"
        width="300px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="loading-dialog"
    >
      <div style="text-align:center; font-size: 24px; margin-bottom: 10px;">
        数据加载中，请稍后…
      </div>
      <div style="text-align:center;">
        <el-icon><loading /></el-icon>
      </div>
    </el-dialog>

    <!-- 自定义查询部分 -->
    <div v-if="selectedTab === '自定义查询'" class="custom-query-container">
      <div class="datetime-container background-box">
        <div class="datetime-group">
          <label style="margin-right: 2%;margin-left: 2%;margin-top:2%">开始: </label>

          <!-- 原来的 <el-date-picker> 改为 <datetime> -->
          <span style="display:block;width:40%;">
                      <datetime
                          input-style="width:100%;font-size:16px;"
                          v-model="startDate"
                          type="date"
                          :format="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          :max-datetime="new Date().toISOString()"
                          class="dt-input"
                      />
          </span>

          <el-button type="primary" style="width: 25%;margin-left:12%;margin-right: 2%" @click="showHourModal('start')">
            {{ startHour ? startHour + '时' : '选择小时' }}
          </el-button>
        </div>

        <div class="datetime-group">
          <label style="margin-right: 2%;margin-left: 2%;margin-top:2%">结束:</label>

          <!-- 同理替换 endDate -->
          <span style="display:block;width:40%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="endDate"
                type="date"
                :format="{
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>

          <el-button type="primary" style="width: 25%;margin-left:12%;margin-right: 2%" @click="showHourModal('end')">
            {{ endHour ? endHour + '时' : '选择小时' }}
          </el-button>
        </div>
      </div>

      <div class="form-row background-box">
        <label style="margin-left:2%;margin-top:1%;margin-right: 1%">榜单:</label>
        <!-- 替换成按钮，点击时显示模态框 -->
        <el-button type="primary" style="width: 15%;margin-right: 1%;" @click="showCategoryModal">
          {{ selectedCategory }}  <!-- 显示选择的榜单 -->
        </el-button>

        <!-- 如果选中玩法榜，则用自动补全 -->
        <div
            v-if="selectedCategory==='玩法榜'"
            class="custom-autocomplete"
            style="width: 30%;margin-right: 2%;font-size: 16px;padding:4px"
        >
          <input
              ref="autocompleteInput"
              v-model="searchQuery"
              type="text"
              placeholder="请输入玩法名"
              @focus="showDropdown"
              @input="onSearchInput"
              @blur="hideSuggestions"
              class="autocomplete-input"
              style="width:100%;font-size:16px;padding:4px"
          />
          <div v-if="showSuggestions" class="autocomplete-dropdown">
            <ul>
              <li
                  v-for="item in filteredSuggestions"
                  :key="item.value"
                  @click="onGameSelect(item)"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <!-- 其他榜单，保留普通输入框 -->
        <div v-else style="min-width:45%;margin-right:2%;">
          <input
              v-model="searchQuery"
              placeholder="玩法或主播名"
              clearable
              style="width: 30%;margin-right: 2%;font-size: 16px;padding:4px"
          />
        </div>

        <el-button type="primary" style="width: 15%;margin-right: 2%;" @click="showQuickSelectModal">
          快速选择
        </el-button>

        <el-button type="primary" @click="onSearch" style="width: 15%;margin-right: 2%;">查询</el-button>
      </div>
    </div>

    <!-- 榜单选择模态框 -->
    <el-dialog v-model="categoryModalVisible" width="40%" title="选择榜单">
      <div class="category-select-container">
        <el-button
            v-for="category in categories"
            :key="category"
            style="width: 100%; margin: 10px 0;"
            @click="selectCategory(category)"
        >
          {{ category }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="categoryModalVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 选择小时模态框 -->
    <el-dialog v-model="hourModalVisible" width="400px" title="选择小时">
      <div class="hour-selector">
        <el-button
            v-for="h in 24"
            :key="h"
            style="width: 22%; margin: 1%;"
            @click="selectHour(h - 1)"
        >
          {{ h - 1 }}时
        </el-button>
      </div>
    </el-dialog>

    <!-- 快速选择模态框 -->
    <el-dialog v-model="quickSelectModalVisible" width="60%" title="快速选择">
      <div class="quick-select-container">
        <div
            class="quick-select-option"
            v-for="option in quickOptions"
            :key="option.value"
            @click="quickSelect = option.value"
        >
          <span class="option-label">{{ option.label }}</span>
          <el-radio :label="option.value" v-model="quickSelect" class="option-radio"></el-radio>
        </div>
      </div>
      <template #footer>
        <el-button @click="quickSelectModalVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuickSelect">确定</el-button>
      </template>
    </el-dialog>

    <!-- 顶部按钮切换 -->
    <div class="button-group" style="margin-top: 3%;">
      <el-button class='my-custom-button' style="margin-top: 1%;margin-right: 2%"
          v-for="btn in tabs"
          :key="btn"
          type="primary"
          :plain="selectedTab !== btn"
          @click="onTabClick(btn)"
      >
        {{ btn }}
      </el-button>
    </div>

    <!-- 排行榜表格 -->
    <el-table
        v-if="selectedTab !== '大盘数据'"
        :data="visibleRows"
        style="width: 100%; margin-top: 16px; border-collapse: collapse;"
        :header-row-style="headerRowStyle"
        :header-cell-style="headerCellStyle"
        :row-class-name="getRowClassName"
        :style="{ 'table-layout': 'fixed','border-radius':'clamp(10px, 2.5vw, 40px)'}"
    >
      <el-table-column
          v-for="col in columnsMap[selectedTab]"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :min-width="col.minWidth"
          align="center"
          :header-cell-style="headerCellStyle"
          :filters="col.filters"
          :filter-method="col.filterMethod"
      >
        <template #default="{ row }">
          <!-- 判断是否是 anchor_num 列 -->
          <div v-if="col.prop === 'anchor_num'">
            <template v-if="row.game_name === '小计' || row.game_name === '总计'">
              <span>{{ row.anchor_num }}</span>
            </template>
            <template v-else>
              <span class="clickable-blue" @click="fetchAnchorData(row.game_name)">
                {{ row.anchor_num }}
              </span>
            </template>
          </div>

          <!-- 判断是否是性别列 -->
          <div v-else-if="col.prop === 'gender'" style="font-size: 16px;">
            {{ row[col.prop] }} <!-- 直接显示转换后的性别文字 -->
          </div>

          <!-- 判断是否是自定义插槽列 -->
          <div v-else-if="col.customSlot" style="font-size: 16px;">
            <template v-if="col.prop === 'anchor_score'">
              <template v-if="row.game_name === '小计' || row.game_name === '总计'">
                <span>{{ formatNumber(row[col.prop]?.value) }}</span>
              </template>
              <template v-else>
                <span class="clickable-blue" @click="fetchAnchorData(row.game_name)">
                  {{ formatNumber(row[col.prop]?.value) }}
                </span>
              </template>
            </template>
            <template v-else>
              <span>{{ formatNumber(row[col.prop]?.value) }}</span>
            </template>
            <span v-if="row[col.prop]?.change !== 0"
                  class="active-change"
                  :class="{
                    'red': row[col.prop]?.change > 0,
                    'green': row[col.prop]?.change < 0
                  }"
                  style="font-size: 12px;">
              ({{ row[col.prop]?.change > 200 ? '>200' : (row[col.prop]?.change < -200 ? '<-200' : row[col.prop]?.change) }}%)
            </span>
          </div>

          <!-- 新增：类别列（仅当有值且不为 '-' 时可点击，点击后按品类拉取列表） -->
          <div v-else-if="col.prop === 'category'">
            <template v-if="row[col.prop] && row[col.prop] !== '-' && row.game_name !== '小计' && row.game_name !== '总计'">
              <span class="clickable-blue" @click="onCategoryClick(row[col.prop])">
                {{ row[col.prop] }}
              </span>
            </template>
            <template v-else>
              <span style="font-size:16px;">{{ row[col.prop] || '-' }}</span>
            </template>
          </div>

          <!-- 新增：玩法名列（玩法榜/主播榜）点击跳转 -->
          <div
              v-else-if="col.prop === 'game_name'"
              style="font-size: 16px;"
          >
            <template v-if="row.game_name && row.game_name !== '小计' && row.game_name !== '总计'">
    <span class="clickable-blue" @click="goGameInfo(row.game_name)">
      {{ row.game_name }}
    </span>
            </template>
            <template v-else>
              <span>{{ row.game_name }}</span>
            </template>
          </div>

          <!-- 新增：昨日畅销榜里的 app_name 也做跳转 -->
          <div
              v-else-if="col.prop === 'app_name'"
              style="font-size: 16px;"
          >
            <template v-if="row.app_name && row.app_name !== '小计' && row.app_name !== '总计'">
    <span class="clickable-blue" @click="goGameInfo(row.app_name)">
      {{ row.app_name }}
    </span>
            </template>
            <template v-else>
              <span>{{ row.app_name }}</span>
            </template>
          </div>

          <div
              v-else-if="col.prop === 'nickname'"
              style="font-size: 16px;"
          >
            <template v-if="row.sec_uid">
              <a
                  :href="`https://www.douyin.com/user/${row.sec_uid}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="clickable-blue"
                  style="text-decoration: none;"
              >
                {{ row.nickname }}
              </a>
            </template>
            <template v-else>
              <span>{{ row.nickname }}</span>
            </template>
          </div>

          <!-- 普通列 -->
          <div v-else style="font-size: 16px;">
            {{ row[col.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格下方控制条 -->
    <div v-if="selectedTab !== '大盘数据'" style="text-align:right; margin-top:8px;">
      <!-- 展开更多（仅当未展开且数据>50时显示） -->
      <el-link
          v-if="!showAll && tableData.length > 50"
          :underline="false"
          @click="showAll = true"
      >
        <img :src="imgClickMore" alt="展开更多" style="height:28px; vertical-align:middle;" />
      </el-link>

      <!-- 返回全部榜单（仅当有品类过滤时显示） -->
      <el-link
          v-if="categoryFilter && selectedTab === '玩法榜'"
          :underline="false"
          @click="resetAllRank"
          style="margin-left:12px;"
      >
        <img :src="imgBackTotal" alt="返回全部排行榜" style="height:28px; vertical-align:middle;" />
      </el-link>
    </div>

    <!-- 活跃主播详情侧边栏 -->
    <el-drawer
        v-model="sidebarVisible"
        title="活跃主播详情"
        :direction="'rtl'"
        size="70%"
        :before-close="handleCloseSidebar"
        :style="{
      position: 'fixed',
      top: drawerTop + 'px',
      zIndex: 1000,
      width: '70%'
    }"
    >
    <!-- 表格区域 -->
    <div :style="{ overflowY: 'auto', padding: '10px' }">
      <el-table :data="anchorList" stripe>
        <el-table-column label="排名" prop="index" width="80" />
        <el-table-column label="主播昵称" min-width="160">
          <template #default="{ row }">
            <a
                v-if="row.sec_uid"
                :href="`https://www.douyin.com/user/${row.sec_uid}`"
                target="_blank"
                rel="noopener noreferrer"
                style="color: #409EFF; text-decoration: none;"
            >
              {{ row.nickname }}
            </a>
            <span v-else>
        {{ row.nickname }}
      </span>
          </template>
        </el-table-column>
        <el-table-column label="房间号" prop="room_id" />
        <el-table-column label="活跃度" prop="total_score" :formatter="formatTotalScore" />
      </el-table>
    </div>
    <!-- 分页器区域 -->
    <div style="text-align:center; margin-top: 10px;">
      <el-pagination
          v-if="anchorPagination.total > 0"
          background
          layout="prev, pager, next, jumper"
          :total="anchorPagination.total"
          :page-size="anchorPagination.per_page"
          :current-page="anchorPagination.current_page"
          @current-change="handleAnchorPageChange">
      </el-pagination>
    </div>
    <template #footer>
      <el-button @click="sidebarVisible = false">关闭</el-button>
    </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted, watch, computed } from 'vue'
import axios from 'axios'
import './common.css'
import './RankTable.css'
import {Datetime} from "vue-datetime3";
import imgClickMore from '@/assets/click4more.png'
import imgBackTotal  from '@/assets/back2total.png'

// === 新增：品类过滤状态 ===
const categoryFilter = ref('')

// 点击类别（类型）单元格时触发：设置过滤并刷新表
function onCategoryClick(cat) {
  if (!cat || cat === '-' ) return
  categoryFilter.value = cat
  // 为了视觉一致，保证当前Tab是“玩法榜”
  selectedTab.value = '玩法榜'
  selectedCategory.value = '玩法榜'
  isLoading.value = true
  fetchData()
}

function resetAllRank() {
  categoryFilter.value = ''
  showAll.value = false
  fetchData()
}

const showAll = ref(false)   // 新增：是否展开全部
const visibleRows = computed(() => {
  if (showAll.value) return tableData.value
  return tableData.value.slice(0, 50)  // 默认展示 50
})

function goGameInfo(name) {
  if (!name) return
  window.location.href = `/new_game_info?game_name=${encodeURIComponent(name)}`
}

const isLoading = ref(false)
const selectedCategory = ref('玩法榜')  // 默认选中的榜单
const categoryModalVisible = ref(false)  // 控制榜单选择模态框的显示
const categories = ['玩法榜', '主播榜', '昨日畅销榜']  // 可选榜单
const searchQuery = ref('')

const displayTime = ref('');

function formatDisplay(date, hour, isEnd = false) {
  const d = new Date(date);
  const y = d.getFullYear();
  let m = (d.getMonth() + 1).toString().padStart(2, '0');
  let day = d.getDate().toString().padStart(2, '0');

  let displayHour = hour ? parseInt(hour, 10) : new Date().getHours();

  if (isEnd) {
    displayHour = displayHour - 1;
    if (displayHour < 0) {
      d.setDate(d.getDate() - 1); // 将日期减1天
      m = (d.getMonth() + 1).toString().padStart(2, '0');
      day = d.getDate().toString().padStart(2, '0'); // 获取新的日期
      displayHour = 23; // 设置小时为 23
    }
  }
  const h = displayHour.toString().padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${isEnd ? '59' : '00'}`;
}


function updateDisplayTime() {
  const start = (startDate.value && startHour.value)
      ? formatDisplay(startDate.value, startHour.value, false)
      : formatDisplay(new Date(), new Date().getHours(), false);
  const end = (endDate.value && endHour.value)
      ? formatDisplay(endDate.value , endHour.value, true)
      : formatDisplay(new Date(), new Date().getHours(), true);
  displayTime.value = `${start} - ${end}`;

  console.log(displayTime.value);
}

// 选择榜单时更新按钮文本
function selectCategory(category) {
  selectedCategory.value = category;
  categoryModalVisible.value = false;
}

// 1. 定义顶部按钮（5 个 Tab）
const tabs = ['玩法榜', '主播榜', '昨日畅销榜', '自定义查询']

// 2. 当前选中的 Tab，默认是“玩法榜”
const selectedTab = ref('玩法榜')

// 3. 定义不同 Tab 下的列配置
const columnsMap = {
  '玩法榜': [
    { label: '预测', prop: 'rank', width: '60' },
    { label: '玩法名称', prop: 'game_name', minWidth: '60' },
    { label: '类型', prop: 'category', minWidth: '50' },
    { label: '活跃主播', prop: 'anchor_num', minWidth: '60' },
    { label: '主播榜活跃', prop: 'anchor_score', minWidth: '100', customSlot: true },
    { label: '玩法榜活跃', prop: 'game_score_total', minWidth: '100', customSlot: true },
    { label: '昨日畅销榜', prop: 'bestseller_rank', minWidth: '70' },  // 新增列
  ],
  '主播榜': [
    { label: '排名', prop: 'rank', width: '60' },
    { label: '玩法名称', prop: 'game_name', minWidth: '120' },
    { label: '主播昵称', prop: 'nickname', minWidth: '120' },
    {
      label: '性别',
      prop: 'gender',
      minWidth: '80',
      filters: [
        { text: '未知', value: '未知' },
        { text: '男', value: '男' },
        { text: '女', value: '女' },
        { text: '男女', value: '男女' },
        { text: '两男', value: '两男' },
        { text: '两女', value: '两女' }
      ],
      filterMethod(value, row) {
        return row.gender === value;
      }
    },
    { label: '活跃度（万）', prop: 'score_str', minWidth: '120' },
  ],
  '昨日畅销榜': [
    { label: '排名', prop: 'rank', width: '60' },
    { label: '玩法名称', prop: 'app_name', minWidth: '120' },
    { label: '分类', prop: 'category', minWidth: '100' },
    { label: '玩法介绍', prop: 'description', minWidth: '180' },
    { label: '开发者', prop: 'developer', minWidth: '120' },
  ],
  '自定义查询': [],
}

// 4. 表格数据
const tableData = ref([])

// 4. 活跃主播详情
const sidebarVisible = ref(false)
const anchorList = ref([])
// 新增一个变量保存分页信息
const anchorPagination = ref({
  current_page: 1,
  per_page: 50,
  total: 0,
  last_page: 1
})
// 保存当前查询的游戏名称，便于翻页时使用
const currentGameName = ref('')

// 5. 点击活跃主播时，获取数据
function fetchAnchorData(gameName, page = 1) {
  const params = {
    start_time: formatDateTime(startDate.value, startHour.value),
    end_time: formatDateTime(endDate.value, endHour.value),
    game_name: gameName,
    page: page
  }
  currentGameName.value = gameName;

  axios.get('https://www.hudongwanfa.cn/api/anchor_game_rank', { params })
      .then(res => {
        if (res.data.code === 0) {
          // 注意：返回数据为 { data: { data: [...], meta: {…} } }
          const responseData = res.data.data
          // 保存分页数据
          anchorPagination.value = responseData.meta
          // 保存主播列表数据，并格式化活跃度显示
          anchorList.value = responseData.data.map(item => ({
            ...item,
            total_score: formatScoreStr(item.total_score)
          }))
          sidebarVisible.value = true
        }
      })
      .catch(err => {
        console.error('获取主播数据失败:', err)
      })
}

function handleAnchorPageChange(page) {
  fetchAnchorData(currentGameName.value, page)
}

// 5. 自定义查询表单数据
const startDate = ref('')
const startHour = ref('')
const endDate = ref('')
const endHour = ref('')
const quickSelect = ref('')
// const startDatePickerOptions = { disabledDate: (time) => time > new Date() }
// const endDatePickerOptions = { disabledDate: (time) => time > new Date() }

// 6. 切换按钮时触发
// 切换Tab时更新columnsMap
function onTabClick(tabName) {
  if (tabName !== '自定义查询') {
    columnsMap['自定义查询'] = columnsMap[tabName];
    selectedCategory.value = tabName;
  }

  // 更新columnsMap
  if (tabName === '自定义查询') {
    initTodayTime();
    // 在自定义查询时设置默认的columnsMap（例如选择玩法榜）
    columnsMap['自定义查询'] = columnsMap[selectedCategory.value];
  }

  selectedTab.value = tabName;
  // 清空控件的值
  if (tabName !== '自定义查询') {
    initTodayTime();

    searchQuery.value = '';
    quickSelect.value = '';
  }
  categoryFilter.value = ''   // 切换Tab时清空品类过滤（可选）
}

// 7. 监听 selectedTab，自动请求后端获取相应数据
watch(selectedTab, () => {
  if (selectedTab.value !== '自定义查询') {
    fetchData()
  }
})

// 8. 从后端获取数据
function fetchData() {
  isLoading.value = true;
  showAll.value = false    // 新增：每次拉新数据后回到“默认只展示50”
  updateDisplayTime();
  // console.log('fetchData selectedTab.value = ' + selectedTab.value, columnsMap, tableData)
  if (selectedTab.value === '主播榜') {
    axios.get('https://www.hudongwanfa.cn/api/anchor_rank', {
      params: {
        nickname: searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value),
        end_time: formatDateTime(endDate.value, endHour.value)
      }
    }).then((res) => {
      const data = res.data.data || []
      const formattedData = data.map(item => ({
        rank: item.index,
        game_name: item.game_name,
        nickname: item.nickname,
        sec_uid: item.sec_uid,
        score_str: formatScoreStr(item.score_str),
        gender: convertGender(item.gender)
      }))
      tableData.value = formattedData

      isLoading.value = false
    }).catch((err) => {
      console.error('获取主播榜数据失败:', err)
    })
  } else if (selectedTab.value === '玩法榜') {
    axios.get('https://www.hudongwanfa.cn/api/game_rank', {
      params: {
        app_name: searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value), // 修改这里
        end_time: formatDateTime(endDate.value, endHour.value),        // 修改这里
        category: categoryFilter.value || undefined,  // 新增：有品类时传给后端
      }
    }).then((res) => {
      const data = res.data.data.data || []
      const formattedData = data.map(item => ({
        rank: item.rank,
        game_name: item.game_name,
        category: item.category,
        anchor_num: item.anchor_num,
        game_score_total: {
          value: item.game_score_total > 10000 ? (item.game_score_total / 10000).toFixed(1) + '万' : item.game_score_total,
          change: item.game_score_change
        },
        anchor_score: {
          value: item.anchor_score > 10000 ? (item.anchor_score / 10000).toFixed(1) + '万' : item.anchor_score,
          change: item.anchor_score_change
        },
        bestseller_rank : item.bestseller_rank,
      }));
      tableData.value = formattedData;

      isLoading.value = false;
    }).catch((err) => {
      console.error('获取玩法榜数据失败:', err)
    })
  } else if (selectedTab.value === '昨日畅销榜') {
    axios.get('https://www.hudongwanfa.cn/api/bestseller_rank', {
      params: {
        date: startDate.value.split(' ')[0] // 只传日期部分
      }
    }).then((res) => {
      const data = res.data.data || []
      const formattedData = data.map(item => ({
        rank: item.index,
        app_name: item.app_name,
        category: item.category,
        description: item.description,
        developer: item.developer,
      }));
      tableData.value = formattedData;

      isLoading.value = false;
    }).catch((err) => {
      console.error('获取畅销榜数据失败:', err)
    })
  }
}

// 格式化日期和小时为完整时间字符串
function formatDateTime(date, hour) {
  if (!date) {
    return ''; // 如果没有选择日期，则返回空
  }

  // 如果没有选择小时，则默认使用00:00
  const formattedDate = new Date(date);

  // 处理时间为 'YYYY-MM-DD HH:mm:ss' 格式
  let formattedTime = '';

  if (!hour) {
    // 如果没有选择小时，默认使用00
    formattedTime = `${formattedDate.getFullYear()}-${(formattedDate.getMonth() + 1).toString().padStart(2, '0')}-${formattedDate.getDate().toString().padStart(2, '0')} 00:00:00`;
  } else {
    // 如果选择了小时
    formattedTime = `${formattedDate.getFullYear()}-${(formattedDate.getMonth() + 1).toString().padStart(2, '0')}-${formattedDate.getDate().toString().padStart(2, '0')} ${hour}:00:00`;
  }

  return formattedTime;
}

// 9. 快速选择日期处理
watch(quickSelect, (value) => {
  const now = new Date();
  let startDateVal, endDateVal;

  // 获取当前日期
  const setToMidnight = (date) => new Date(date.setHours(0, 0, 0, 0)); // 设置为当天00:00

  if (value === 'yesterday') {
    // 昨天的日期从00:00到今天的00:00
    startDateVal = setToMidnight(new Date(now.setDate(now.getDate() - 1)));
    endDateVal = setToMidnight(new Date()); // 今天00:00
  } else if (value === 'beforeYesterday') {
    // 前天的日期从00:00到昨天的00:00
    const twoDaysAgo = new Date(now);
    twoDaysAgo.setDate(now.getDate() - 2); // 计算前天
    startDateVal = setToMidnight(twoDaysAgo); // 前天00:00
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1); // 计算昨天
    endDateVal = setToMidnight(yesterday); // 昨天00:00
  } else {
    // 今天的日期从00:00到明天的00:00
    startDateVal = setToMidnight(now); // 今天00:00
    endDateVal = setToMidnight(new Date(now.setDate(now.getDate() + 1))); // 明天00:00
  }

  // 更新startDate, startHour, endDate, endHour
  startDate.value = formatDateString(startDateVal);
  startHour.value = formatHourString(startDateVal.getHours());
  endDate.value = formatDateString(endDateVal);
  endHour.value = formatHourString(endDateVal.getHours());
})

// 10. 点击查询按钮触发
function onSearch() {
  // 获取当前时间
  const now = new Date();
  const currentDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), 0, 0, 0); // 当前小时的起始时间
  const nextHourDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 1, 0, 0, 0); // 下一个小时的起始时间

  // 用户选择的起始时间
  const startDateTime = new Date(startDate.value + ' ' + startHour.value + ':00:00');

  // 如果起始时间大于当前时间，将起始时间改为当前小时的起始时间
  if (startDateTime > currentDateTime) {
    startDate.value = formatDateString(now); // 设置为当前日期
    startHour.value = currentDateTime.getHours().toString().padStart(2, '0'); // 设置为当前小时
  }

  // 用户选择的结束时间
  const endDateTime = new Date(endDate.value + ' ' + endHour.value + ':00:00');

  // 如果结束时间大于当前时间，将结束时间改为下一个小时的起始时间
  if (endDateTime > nextHourDateTime) {
    endDate.value = formatDateString(now); // 设置为当前日期
    endHour.value = nextHourDateTime.getHours().toString().padStart(2, '0'); // 设置为下一个小时
  }

  // 根据查询类别动态更新columnsMap
  columnsMap['自定义查询'] = columnsMap[selectedCategory.value];

  if (selectedTab.value === '自定义查询') {
    fetchDataByCategory();  // 调用根据查询类别获取数据的函数
  } else {
    fetchData();  // 继续使用原来的 fetchData 获取数据
  }
}

// 获取行的 class name，用于设置不同的行颜色
function getRowClassName({ rowIndex }) {
  return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
}

// 9. 格式化数字显示
function formatNumber(value) {
  return value ? value : '-'
}

// 10. 格式化活跃度显示
function formatScoreStr(score) {
  const scoreValue = parseFloat(score)
  return scoreValue >= 10000 ? (scoreValue / 10000).toFixed(1) + '万' : score
}

// 12. 表头单元格样式
function headerCellStyle() {
  return {
    backgroundColor: '#4a649e',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '16px'
  }
}

// 13. 表头行样式
function headerRowStyle() {
  return { backgroundColor: '#f2f2f2', fontWeight: 'bold' }
}

function initTodayTime() {
  const now = new Date();

  // 设置为今天00:00
  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0);  // 今天00:00
  startDate.value = formatDateString(startOfDay);
  startHour.value = '00';  // 设置为00:00

  // 设置结束时间为下一小时的00:00
  const endOfHour = new Date(now);
  endOfHour.setHours(now.getHours() + 1, 0, 0, 0);  // 下一小时的00:00
  endDate.value = formatDateString(endOfHour);
  endHour.value = endOfHour.getHours().toString().padStart(2, '0');  // 设置为下一小时
}

// 14. 组件挂载后，默认请求一次数据
onMounted(() => {
  initTodayTime()

  fetchData()

  // 监听窗口大小变化
  window.addEventListener('resize', updateContentHeight)

  // 使用 MutationObserver 监听整个 body 的变化（如果页面结构中 header/footer 发生了变化也会重新计算高度）
  observer = new MutationObserver(updateContentHeight)
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true
  })
})

function formatDateString(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
}

function formatHourString(hour) {
  return hour ? hour : '00';
}

function convertGender(gender) {
  const genderMap = {
    0: '未知',
    1: '男',
    2: '女',
    3: '男女',
    4: '两男',
    5: '两女'
  };
  return genderMap[gender] || '未知';
}


// 根据查询类别获取数据
function fetchDataByCategory() {
  isLoading.value = true;
  showAll.value = false    // 新增：每次拉新数据后回到“默认只展示50”

  updateDisplayTime();

  // 根据查询类别获取数据
  if (selectedCategory.value === '主播榜') {
    axios.get('https://www.hudongwanfa.cn/api/anchor_rank', {
      params: {
        nickname: searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value),
        end_time: formatDateTime(endDate.value, endHour.value)
      }
    }).then((res) => {
      const data = res.data.data || [];
      const formattedData = data.map(item => ({
        rank: item.index,
        game_name: item.game_name,
        nickname: item.nickname,
        sec_uid: item.sec_uid,
        score_str: formatScoreStr(item.score_str),
        gender: convertGender(item.gender)
      }));
      tableData.value = formattedData;
      isLoading.value = false;
    }).catch((err) => {
      console.error('获取主播榜数据失败:', err);
      isLoading.value = false;
    });
  } else if (selectedCategory.value === '玩法榜') {
    axios.get('https://www.hudongwanfa.cn/api/game_rank', {
      params: {
        app_name: searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value),
        end_time: formatDateTime(endDate.value, endHour.value),
        category: categoryFilter.value || undefined,  // 新增
      }
    }).then((res) => {
      const data = res.data.data.data || [];
      const formattedData = data.map(item => ({
        rank: item.rank,
        game_name: item.game_name,
        category: item.category,
        anchor_num: item.anchor_num,
        game_score_total: {
          value: item.game_score_total > 10000 ? (item.game_score_total / 10000).toFixed(1) + '万' : item.game_score_total,
          change: item.game_score_change
        },
        anchor_score: {
          value: item.anchor_score > 10000 ? (item.anchor_score / 10000).toFixed(1) + '万' : item.anchor_score,
          change: item.anchor_score_change
        },
        bestseller_rank: item.bestseller_rank,
      }));
      tableData.value = formattedData;
      isLoading.value = false;
    }).catch((err) => {
      console.error('获取玩法榜数据失败:', err);
      isLoading.value = false;
    });
  } else if (selectedCategory.value === '昨日畅销榜') {
    axios.get('https://www.hudongwanfa.cn/api/bestseller_rank', {
      params: {
        date: startDate.value.split(' ')[0] // 只传日期部分
      }
    }).then((res) => {
      const data = res.data.data || [];
      const formattedData = data.map(item => ({
        rank: item.index,
        app_name: item.app_name,
        category: item.category,
        description: item.description,
        developer: item.developer,
      }));
      tableData.value = formattedData;
      isLoading.value = false;
    }).catch((err) => {
      console.error('获取畅销榜数据失败:', err);
      isLoading.value = false;
    });
  }
}

// 新增状态变量
const hourModalVisible = ref(false)
const quickSelectModalVisible = ref(false)
const selectingHourFor = ref('')

// 显示选择小时模态框
function showHourModal(type) {
  selectingHourFor.value = type;
  hourModalVisible.value = true;
}

// 用户选择小时后执行
function selectHour(hour) {
  if (selectingHourFor.value === 'start') {
    startHour.value = hour.toString().padStart(2, '0');
  } else {
    endHour.value = hour.toString().padStart(2, '0');
  }
  hourModalVisible.value = false;
}

// 显示快速选择模态框
function showQuickSelectModal() {
  quickSelectModalVisible.value = true;
}

// 确定快速选择后执行
function confirmQuickSelect() {
  quickSelectModalVisible.value = false;
  // 此时quickSelect已经被绑定，触发原有逻辑即可
}

const quickOptions = [
  { label: '今天', value: 'today' },
  { label: '昨天', value: 'yesterday' },
  { label: '前天', value: 'beforeYesterday' }
]

// 监听查询类别变化
watch(selectedCategory, () => {
  if (selectedTab.value === '自定义查询') {
    // 当选择查询类别时，更新columnsMap
    columnsMap['自定义查询'] = columnsMap[selectedCategory.value];
  }
});

// 添加showCategoryModal函数来显示模态框
function showCategoryModal() {
  categoryModalVisible.value = true; // 打开榜单选择的模态框
}

import { onBeforeUnmount } from 'vue'

// 用于存储内容区域的最大高度，初始值设为视口高度减去 header/footer 占用空间（这里假设 120px）
const contentHeight = ref(window.innerHeight)
const drawerTop = ref(0);

const updateContentHeight = () => {
  // 动态获取当前视口高度，减去 header/footer 的高度（可根据实际情况调整）
  const currentWidth = window.innerWidth

  if (currentWidth <= 768) {
    contentHeight.value = 768 / window.innerWidth * window.innerHeight - 120
    drawerTop.value = 768 / window.innerWidth * window.scrollY;
    // console.log('windows is', window)
    // console.log('window.innerWidth', window.innerWidth, ' window.scrollY=', window.scrollY, ' drawerTop.value=', drawerTop.value);
  }
}

let observer = null

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateContentHeight)
  if (observer) {
    observer.disconnect()
  }
})

// --- 自动补全用到的变量 ---
const filteredSuggestions = ref([])      // 下拉列表数据
const showSuggestions      = ref(false)  // 控制下拉框显示
const autocompleteInput    = ref(null)   // 输入框 DOM 引用
const dropdownStyle = reactive({        // 下拉框定位与样式
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%',
      background: '#fff',
      border: '1px solid #ccc',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000
})

/**
 + * 当用户输入时调用，向后端请求匹配的玩法名
 + */
const onSearchInput = async () => {
  const q = searchQuery.value.trim()
  if (!q) {
    filteredSuggestions.value = []
    return
  }
  try {
    const res = await axios.get('https://www.hudongwanfa.cn/api/search_game_dy', {
      params: { game_name: q }
    })
    filteredSuggestions.value = res.data.data.map(item => ({
          label: item.game_name,
          value: item.game_name
    }))
    // 如果有数据，则保持下拉打开并调整位置
    if (filteredSuggestions.value.length) {
      showSuggestions.value = true
      adjustDropdownPosition()
    }
  } catch (err) {
    console.error('拉取玩法补全失败:', err)
  }
}

/**
 + * 显示下拉框，并定位
 + */
const showDropdown = () => {
  showSuggestions.value = true
  adjustDropdownPosition()
}

/**
 + * 隐藏下拉框（加点延迟，避免点击时立刻消失）
 + */
const hideSuggestions = () => {
  setTimeout(() => { showSuggestions.value = false }, 100)
}

/**
 + * 点击某项后赋值并收起列表
 + */
const onGameSelect = (item) => {
  searchQuery.value = item.value
  showSuggestions.value = false
}

/**
 + * 根据输入框位置，更新下拉框的 absolute 定位
 + */
const adjustDropdownPosition = () => {
  nextTick(() => {
    if (!autocompleteInput.value) return
    const rect = autocompleteInput.value.getBoundingClientRect()
    dropdownStyle.top    = rect.bottom + 'px'
    dropdownStyle.left   = rect.left   + 'px'
    dropdownStyle.width  = rect.width  + 'px'
  })
}

</script>

<style scoped>
/* NewGameList.vue 或全局样式里加入下面这段 */

.custom-autocomplete {
  position: relative;
  display: inline-block;      /* 保证宽度由子元素撑开 */
  width: 100%;                /* 如果你想让输入框占满父容器，就加这一行 */
  box-sizing: border-box;     /* 边框和内边距都算在 width 里 */
}

.autocomplete-input {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  box-sizing: border-box;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;                  /* 紧贴输入框底部 */
  left: 0;
  width: 100%;                /* 跟输入框同宽 */
  max-height: 250px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 10;
  box-sizing: border-box;
}

.autocomplete-dropdown ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.autocomplete-dropdown li {
  padding: 6px 12px;
  cursor: pointer;
}

.autocomplete-dropdown li:hover {
  background-color: #f5f5f5;
}

</style>